export * from './src/filter-bar.component';
